<template>
    <div>
      <h2>Room Details</h2>
      <p>{{ room.name }}</p>
      <!-- Add more room details and edit functionality here -->
    </div>
  </template>

  <script>
  import { mapState } from 'vuex';

  export default {
    name: 'RoomDetails',
    computed: {
      ...mapState({
        room: state => state.tenantRooms.find(room => room.id === parseInt(this.$route.params.id)),
      }),
    },
  };
  </script>
